import { Col } from "react-bootstrap";
import { pausedCampaignAlertLabels } from "@revbox/localization";
import { useCookiesContext } from "../../../../../contexts/CookiesContext";

export default function PausedCampaignAlert({
    isCampaignPaused,
    closedAlert,
    setClosedAlert,
}) {
    const { getLanguageAbbr } = useCookiesContext();
    const languageAbbr = getLanguageAbbr();
    const multilang = pausedCampaignAlertLabels[languageAbbr];

    return (
        isCampaignPaused ? (
            !closedAlert ? (
              <Col md="12">
                <div className="fade alert alert-dismissible danger-system-alert show mb-0">
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close alert"
                    onClick={() => setClosedAlert(true)}
                  ></button>
                  <div className="banner">
                    <h3 className="banner-title">
                      {multilang.title}
                    </h3>
                    <p className="banner-text">
                      {multilang.message}
                    </p>
                  </div>
                </div>
              </Col>
            ) : (
              <></>
            )
          ) : (
            <></>
          )
    )
}